import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { ClientService } from '../../../services/client.service';
import { CatalogService } from '../../../services/catalog.service';
import { InvoiceService } from '../../../services/invoice.service';
import { encode_base64, encode_utf8 } from '../../../../environments/environment';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';
import { SharedService } from '../../../services/shared.service';

declare var $: any;

@Component({
  selector: 'ngx-work-financial',
  templateUrl: './financial.component.html',
})
export class FinancialComponent implements OnInit {

  payment_record = true;
  balance_record = false;
  hold_checks = false;
  return_checks = false;

  page_number_payment_record = 1;
  page_number_hold_checks = 1;
  page_number_return_checks = 1;

  start_date:string
  end_date:string

  private _client_no: number;

  @Input() set client_no(value: number) {
    this._client_no = value;
    // this.petService.getPetCheckIn(this.petService.current_client_no).then(() => { });
  }

  get client_no(): number {
    return this._client_no;
  }

  constructor(
    public clientService: ClientService,
    public catalogService: CatalogService,
    private datePipe: DatePipe,
    public invoiceService: InvoiceService,
    public sharedService: SharedService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    let scurrentDate =  this.datePipe.transform(new Date(), 'yyyy-MM-dd')
    this.start_date = scurrentDate
    this.end_date = scurrentDate
    this.invoiceService.GetClientInvReport(this.client_no,this.start_date,this.end_date)
  }

  save() {
    Swal.fire({
      title: 'Loading...',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
      },
    })

    this.clientService.setupClient()
      .then(() => {
        Swal.fire({
          title: 'Your information has been saved.',
          didOpen: () => {
          },
        })
      });
  }

  ver(tipo: string) {
    this.payment_record = tipo === 'payment_record'
    this.balance_record = tipo === 'balance_record'
    this.hold_checks = tipo === 'hold_checks'
    this.return_checks = tipo === 'return_checks'
  }

  filter() {
    this.cashiers = [...new Set(this.clientService.client_cash_reg.map(item => item.cashier))].sort();
    this.payments = [...new Set(this.clientService.client_cash_reg.map(item => item.payment_desc))].sort();
    this.reasons = [...new Set(this.clientService.client_cash_reg.map(item => item.check_card))].sort();

    $('#modalFilterFinancial').modal('toggle');
  }

  view_page_cash_reg(page: number) {
    this.page_number_payment_record = page;
  }

  view_page_hold_check(page: number) {
    this.page_number_hold_checks = page;
  }

  view_page_return_checks(page: number) {
    this.page_number_return_checks = page;
  }

  apply() {
    $('#modalFilterFinancial').modal('toggle');
  }

  clear() {
    this.reason = '';
    this.payment = '';
    this.cashier = '';
    this.from = '';
    this.to = '';
  }
 
  printinvoice(inv_no,pet_no) { 
    let $string = `admin` + "U*63r" + 'FPC_RptInvReceipt' + "R0d&3" + 'pdf' + "R3nd%" + '' + "Fr3n6" + `Invoice Receipt #${inv_no} ${new Date().getTime()}` + "T1*73";
    let $result = encode_utf8($string);
    $result = encode_base64($result);
 
    let $strfilter = `&invoice_no=${inv_no}&pet_no=${pet_no}&clinic_no=${this.invoiceService.userData.clinic_no}&client_no=${this.client_no}`;
    console.log($strfilter);

    let url = `https://ssrs.itimpact.com/fpc_ssrs/default.aspx?token=${$result}${$strfilter}`;
    console.log(url);

    window.open(url, '_self', 'visible=none');
  }

  print() { 
    let $string = `admin` + "U*63r" + 'FPC_ClientInvoiceRpt' + "R0d&3" + 'pdf' + "R3nd%" + '' + "Fr3n6" + `Client Invoice #${this.client_no} ${new Date().getTime()}` + "T1*73";
    let $result = encode_utf8($string);
    $result = encode_base64($result);
 
    let $strfilter = `&client_no=${this.client_no}&start_date=${this.start_date}&end_date=${this.end_date}`;
    console.log($strfilter);

    let url = `https://ssrs.itimpact.com/fpc_ssrs/default.aspx?token=${$result}${$strfilter}`;
    console.log(url);

    window.open(url, '_self', 'visible=none');
  }

  original_receipt(file_id) {
    this.sharedService.viewPdf(file_id);
  }





  dateOnChange(){
    this.invoiceService.GetClientInvReport(this.client_no,this.start_date,this.end_date)
  }

  //Filters
  payments: string[] = [];
  reasons: string[] = [];
  cashiers: string[] = [];

  reason: string = '';
  payment: string = '';
  cashier: string = '';
  from: string = '';
  to: string = '';
}
